function hideLettersOfString(text: string, numberOfLettersToShow: number) {
  if (text.length <= numberOfLettersToShow) return text;

  const short = text.substring(0, numberOfLettersToShow);

  return `${short}****`;
}

export default hideLettersOfString;
